import {createContext} from "react";

export const AgentRequestContext = createContext({
  agentRequest: {
    id: "",
    name: "",
    family: "",
    father_name: "",
    national_code: "",
    birth_date: "",
    gender: "",
    photo: "",
    degree_id: null,
    stage_degree_id: null,
    degree_file: "",
    home_phone: "",
    province_id: null,
    city_id: null,
    email: "",
    address: "",
    experience: "",
    speciality: "",
    about_me: "",
    resume_file: "",
    introduction_file: "",
    introduction: "",
    step: null,
    status: "",
    branch_ids: null,
  },
  setAgentRequest: () => {

  },
  agentLog: {
    id: null,
    agent_id: null,
    admin_id: null,
    comment: "",
    status: "",
    create_date: "",
  },
  setAgentLog: () => {

  },
  activeStep: null,
  setActiveStep: () => {

  },
  isLastStep: false,
  setIsLastStep: () => {

  },
  isFirstStep: false,
  setIsFirstStep: () => {

  },
  allowedStep: null,
  setAllowedStep: () => {

  },
  handleNext: () => {

  },
  handlePrev: () => {
    
  },

})